//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/TaggedObjectCollection.js";
import "../no/ugmath.js";
import "../Routing/Routing.RouteManager.js";
let d=[[],[[["position","tolerance"],"FindControlPoint",{R_:{controlpoint:"Routing.ControlPoint"}},2,0],[["position","check_existing","found_existing"],"CreateControlPoint",{R_:{controlpoint:"Routing.ControlPoint"}},2,0],[["port","check_existing","found_existing"],"CreateControlPointAtPort",{R_:{controlpoint:"Routing.ControlPoint"}},2,0],[["object","object_parm","check_existing","found_existing"],"CreateControlPoint1",{R_:{controlpoint:"Routing.ControlPoint"}},3,0],[["point","check_existing","found_existing"],"CreateControlPointAtPoint",{R_:{controlpoint:"Routing.ControlPoint"}},2,0],[["conic","check_existing","found_existing"],"CreateControlPointByConicCenter",{R_:{controlpoint:"Routing.ControlPoint"}},2,0],[["start_object","offset","check_existing","found_existing"],"CreateControlPointByWcsOffset",{R_:{controlpoint:"Routing.ControlPoint"}},3,0],[["cp_occ","check_existing","found_existing"],"CreateControlPointByControlPointOccurrence",{R_:{controlpoint:"Routing.ControlPoint"}},2,0]],[]];
SPLM.Routing.ControlPointCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Routing.ControlPointCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

SPLM.Routing.ControlPointCollection.CheckExisting = Object.freeze({
    "DontSearch" : "DontSearch", "Search" : "Search"});

SPLM.Routing.ControlPointCollection.FoundExisting = Object.freeze({
    "BrandNew" : "BrandNew", "Existing" : "Existing"});

export default SPLM;